// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );


// Timeline init
let quality_tl = gsap.timeline( { defaults: { repeat: 0, duration: 0.5, ease: 'power4.out'} } );

if( $('body').hasClass('who-we-are-page') ) {
    // SCROLLING ANIMATIONS
    // Tween 1: title fade down
    quality_tl.from( 
        $('#quality h2'), 
        {
            // scrollTrigger: {
            //     trigger: '#quality',
            //     start: "0% 80%",
            //     end: "0% 50%",
            //     scrub: 2,
            // },
            y: -30,
            // duration: 4,

            ease: 'back.out(1.1)'
        },
    );
    // Tween 2: image border appear
    quality_tl.from( 
        $('#quality .text-container p'), 
        {
            // scrollTrigger: {
            //     trigger: '#quality',
            //     start: "0% 80%",
            //     end: "0% 50%",
            //     scrub: 2,
            // },
            autoAlpha: 0,
            stagger: 0.1,
            yPercent: 40,
            // duration: 4,

            ease: 'back.out(1.1)'
        },
    );

    // Tween 4: title up
    quality_tl.from( 
        $('#quality .imgs-container img'), 
        {
            // scrollTrigger: {
            //     trigger: '#quality',
            //     start: "0% 80%",
            //     end: "0% 50%",
            //     scrub: 2,
            // },
            autoAlpha: 0,
            stagger: 0.1,
            yPercent: 50,
            // duration: 4,
            ease: 'back.out(1.1)'
        },
    );

}